import { useMemo } from 'react';
import { useGetGeoLocation } from '@/modules/Customer/http/client/useGetGeoLocation';
import { getCookie, setCookie } from '@/utils/cookies';

type GeoData = {
  ip?: string;
  city?: string;
  region?: string;
  country?: string;
};

type Data = {
  geoData?: GeoData;
  error?: string;
  hasGeoData?: boolean;
};

const useGeoLocation = () => {
  const { data, isError } = useGetGeoLocation();

  const { geoData, error, hasGeoData }: Data = useMemo(() => {
    const cookieGeoData = getCookie('geoData');
    if (cookieGeoData)
      return { geoData: JSON.parse(cookieGeoData), hasGeoData: true };

    if (data) {
      const geoData = {
        ip: data?.ip || data?.IPv4,
        city: data?.city,
        region: data?.region_code || data?.region || data?.state,
        country: data?.country || data?.country_code || data?.country_name,
      };

      setCookie('geoData', JSON.stringify(geoData));
      return { geoData, hasGeoData: true };
    }

    if (isError) return { error: 'Failed to fetch geolocation data' };

    return {} as Data;
  }, [data, isError]);

  return { geoData, error, hasGeoData };
};

export default useGeoLocation;
